import request from '@/utils/request'

// 添加会议室
export function upload(fileObj) {
  const formdata = new FormData()
  // formdata.append('files', [fileObj.file, fileObj.file.name]);
  formdata.append('files', [fileObj.file])
  formdata.append('upload_type', 'image')
  return request({
    url: `/common/upload`,
    method: 'post',
    data: formdata
  })
}

// 评分维度列表
export function searchScoringDimension(params) {
  return request({
    url: '/setting/search',
    method: 'post',
    data: params
  })
}
// 新建评分维度
export function addScoringDimension(params) {
  return request({
    url: '/setting',
    method: 'post',
    data: params
  })
}

// 编辑评分维度
export function editScoringDimension(params) {
  return request({
    url: '/setting/edit/' + params.id,
    method: 'post',
    data: params
  })
}
// 删除评分维度
export function deleteScoringDimension(id) {
  return request({
    url: '/setting/delete/' + id,
    method: 'get'
  })
}
// 获取评分列表
export function getScoreList(params) {
  return request({
    url: '/comment/search',
    method: 'post',
    data: params
  })
}
// 获取评分列表
export function getScoreDetail(params) {
  return request({
    url: '/comment/detail/search',
    method: 'post',
    data: params
  })
}
// 提交评分列表
export function submitScore(params) { // 提交评分http://190.168.1.50:9095/api/comment
  return request({
    url: '/comment',
    method: 'post',
    data: params
  })
}

export function getAttendees(params) { // 提交评分http://190.168.1.50:9095/api/comment
  return request({
    url: '/attendees/search',
    method: 'post',
    data: params
  })
}
